<h1 class="page-header" [class.branding-accent-dark-foreground]="type !== 'account'" [class.mod-account]="type === 'account'">
  {{header | translate}}
</h1>
<h2 *ngIf="subHeader" class="page-subheader branding-accent-normal-foreground">
  {{subHeader | translate}}
</h2>
<ng-content></ng-content>
